import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveResourceFromResourceGroupRequestFailure(group, resource) {
      const req = getState().find(
        (req) =>
          req.group.uuid === group.uuid && req.resource.uuid === resource.uuid,
      );

      return req ? req.requestState.isFailure : false;
    },
    isRemoveResourceFromResourceGroupRequestPending(group, resource) {
      const req = getState().find(
        (req) =>
          req.group.uuid === group.uuid && req.resource.uuid === resource.uuid,
      );

      return req ? req.requestState.isPending : false;
    },
    isRemoveResourceFromResourceGroupRequestSuccess(group, resource) {
      const req = getState().find(
        (req) =>
          req.group.uuid === group.uuid && req.resource.uuid === resource.uuid,
      );

      return req ? req.requestState.isSuccessful : false;
    },
  };
}

export { createSelector };
